export const paths = ['/timecard-preferences'];
